export enum CounterMonitoringView {
  Graph = 'graph',
  Table = 'table',
}

export enum AssetsSidebarView {
  Assets = 'Assets',
  Counters = 'Counters',
}
